import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import cx from 'classnames/bind';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { genericAction } from '../../../../actions';
import BaseLayout from '../../../../components/Layout/Brand/BaseLayout';
import SubmissionMetricsComponent from '../../../../components/Brand/Other/SubmissionMetrics';
import Loader from '../../../../components/UIElems/Loader';
import notification from '../../../../components/UIElems/Notification';

const SubmissionMetrics = (props) => {
    const [isLoading, setIsLoading] = useState(false);

    const taskCaller = (data) => {
        if(window.confirm('Queue task?')) {
            setIsLoading(true);
            props.actions.genericAction('brandCampaignSubmissionMetricsCollect', [data])
            .then(() => {
                notification.send({device: props.rdx.appReducer.deviceType, message: 'Queued!', type: 'success'});
                setIsLoading(false);
            })
        }
    } 

    return (
        <div>
            <SubmissionMetricsComponent taskCaller={taskCaller} />

            { isLoading && <Loader /> }
        </div>
    );
}

//map state
const mapStateToProps = (state, ownProps) => ({rdx: state});

//map dispatch
const mapDispatchToProps = (dispatch, ownProps) => ({
    actions: bindActionCreators({
        genericAction
    }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionMetrics);
